import { render, staticRenderFns } from "./ImeiHistory.vue?vue&type=template&id=42616888&scoped=true&"
import script from "./ImeiHistory.vue?vue&type=script&lang=js&"
export * from "./ImeiHistory.vue?vue&type=script&lang=js&"
import style0 from "./ImeiHistory.vue?vue&type=style&index=0&id=42616888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42616888",
  null
  
)

export default component.exports